export default __webpack_public_path__ + "static/media/yeopen_main_mobile@2x.7a42a807.jpg";